import { Stack } from '@mui/material';
import { Input } from 'components/Inputs';
import { CampaignCreationNextButton } from 'modules/campaign-creation/components/CampaignCreationNextButton';
import { useFormik } from 'formik';
import { useCampaignCreationStore } from 'modules/campaign-creation/stores/useCampaignCreationStore';
import { Flags } from 'services/flags/constants';
import { useFlag } from 'services/flags/hooks';
import Yup from 'utils/validation';
import { useSaveStateCampaign } from 'modules/campaign-creation/hooks/useSaveStateCampaign';

export const CampaignCreationJobDescriptionNoATS: React.FC = () => {
  const state = useCampaignCreationStore((state) => state.state);
  const noATSJobDescriptionState = state?.noATSJobDescriptionState;

  const onNoATSJobDescriptionSubmit = useCampaignCreationStore(
    (store) => store.onNoATSJobDescriptionSubmit
  );

  const isExternalIdRequiredFlag = useFlag(Flags.EXTERNAL_ID_IS_MANDATORY);
  const formik = useFormik({
    initialValues: {
      jobDescriptionText: noATSJobDescriptionState?.jobDescriptionText || '',
      externalId: noATSJobDescriptionState?.externalId || ''
    },
    onSubmit: (values) => {
      if (!values.jobDescriptionText) {
        return;
      }

      onNoATSJobDescriptionSubmit({
        jobDescriptionText: values.jobDescriptionText,
        externalId: values.externalId || null
      });
    },
    validationSchema: Yup.object({
      jobDescriptionText: Yup.string().required('Enter a job description.'),
      externalId: isExternalIdRequiredFlag
        ? Yup.string().required('Enter an external ID.')
        : Yup.string()
    })
  });

  useSaveStateCampaign({
    jobDescriptionText: formik.values.jobDescriptionText,
    externalId: formik.values.externalId
  });

  const { handleBlur, handleChange, errors, values } = formik;

  return (
    <Stack direction="column" gap="30px" width="900px">
      <Input
        label="Job information"
        subLabel="E.g. job description, salary, company culture, working hours etc. This cannot be changed once the campaign is live."
        multiline
        rows={16}
        name="jobDescriptionText"
        value={values.jobDescriptionText}
        onChange={handleChange}
        onBlur={handleBlur}
        error={errors.jobDescriptionText ? true : undefined}
        errorText={errors.jobDescriptionText}
      />
      <Input
        label={`${
          isExternalIdRequiredFlag ? 'External ID' : 'External ID (optional)'
        }`}
        sx={{
          width: '400px'
        }}
        subLabel="Identifies your campaign in Popp’s API."
        name="externalId"
        value={values.externalId}
        onChange={handleChange}
        onBlur={handleBlur}
        error={errors.externalId ? true : undefined}
        errorText={errors.externalId}
      />
      <Stack direction="row">
        <CampaignCreationNextButton
          handleNext={() => {
            formik.handleSubmit();
          }}
        />
      </Stack>
    </Stack>
  );
};
